<template>
<div class="accountInfo padding-20 bgc box-shadow">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'accountInfo',
    data() {
        return {
        }
    },
    methods: {
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.accountInfo {
}
</style>
